export default __webpack_public_path__ + "static/media/project-completed-status.f8a65c94.svg";